import {Component, prop, watch} from 'vue-property-decorator';
import {Adjustment} from './adjustment/adjustment';

@Component({
    template: require('./column.html'),
    components: {
        adjustment: Adjustment,
    }
})
export class Column {
    @prop(Array)
    adjustments;

    @prop(Object)
    nutrients;

    @prop(Object)
    ingredients;

    @prop(Object)
    diet;

    @prop(Number)
    i;

    remove() {
        this.$emit('remove');
    }

    getNutrientMin(nutrient) {
        return this.diet.getNutrientMin(nutrient.id);
    }

    getNutrientMax(nutrient) {
        return this.diet.getNutrientMax(nutrient.id);
    }
}
